/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/9/5      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {Fragment,PureComponent} from "react";
import Lang from "@/components/Lang/Lang";
import {Spin,} from 'antd';
import RemindDrawer from "../remindDrawer/RemindDrawer";
import DopIndexAction from "../../dopIndex.action";

export default class Remind extends PureComponent {
    static defaultProps = {
        orderModel: {}, // 显示
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    //子项
    renderItem(title,num=0,onlyChild=false){
        return (onlyChild?<Fragment>
            <div className={"black66 lineH_21"}>{title}</div>
            <div className={"font_16 fw_700 lineH_24"}>{num}</div>
        </Fragment>:<div className={"commonBox item"}>
            <div className={"black66 lineH_21"}>{title}</div>
            <div className={"font_16 fw_700 lineH_24"}>{num}</div>
        </div>)
    }
    /**
     * 首页 跟进提醒客户统计
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8308
     */
    getRemind() {
        this.loading(true);
        DopIndexAction.postHttpAction("service/mg/home/follow/remind",{
        }).then(res=>this.getTodoRes(res.data)).catch(err=>this.getTodoRes(err));
    }
    getTodoRes(res){
        this.loading(false);
        const {success,valid,model={},} = res;
        if (success && valid) {
            this.setState({
                remindModel:model
            })
        }
    }
    componentWillMount() {
        this.getRemind()
    }

    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }

    render() {
        const {loading = true,remindModel={}} = this.state;
        return (<Spin spinning={loading}>
            <div className={"font_18 fw_500 lineH_27"}>{Lang({ id: "ZhuCeKeHuDaiBanTiXing", default:'注册客户—待办提醒' })}</div>
            <div className={"mt_4 flex-item flexHeight"}>
                <RemindDrawer className={"commonBox item"} btnName={Lang({ id: "DaiChuBuLianXiKeHu", default:'待初步联系客户' })}
                              refreshData={()=>this.getRemind()}
                              labelCode={10}//10:待初步联系 30:选品 40:下单 60:成交未实现
                              canOpen={remindModel.waitContactBuyerNum>0}>
                    {this.renderItem(Lang({ id: "DaiChuBuLianXiKeHu", default:'待初步联系客户' }),remindModel.waitContactBuyerNum,true)}
                </RemindDrawer>
                <RemindDrawer className={"commonBox item"} btnName={Lang({ id: "KeHuXuanPin", default:'客户选品' })}
                              refreshData={()=>this.getRemind()}
                              labelCode={30}//10:待初步联系 30:选品 40:下单 60:成交未实现
                              canOpen={remindModel.addToCartBuyerNum>0}>
                    {this.renderItem(Lang({ id: "KeHuXuanPin", default:'客户选品' }),remindModel.addToCartBuyerNum,true)}
                </RemindDrawer>
                <RemindDrawer className={"commonBox item"} btnName={Lang({ id: "XiaDan", default:'下单' })}
                              refreshData={()=>this.getRemind()}
                              labelCode={40}//10:待初步联系 30:选品 40:下单 60:成交未实现
                              canOpen={remindModel.orderBuyerNum>0}>
                    {this.renderItem(Lang({ id: "XiaDan", default:'下单' }),remindModel.orderBuyerNum,true)}
                </RemindDrawer>
                <RemindDrawer className={"commonBox item"} btnName={Lang({ id: "ChengJiaoWeiShiXian", default:'成交失败' })}
                              refreshData={()=>this.getRemind()}
                              labelCode={60}//10:待初步联系 30:选品 40:下单 60:成交未实现
                              canOpen={remindModel.failDealBuyerNum>0}>
                    {this.renderItem(Lang({ id: "ChengJiaoWeiShiXian", default:'成交失败' }),remindModel.failDealBuyerNum,true)}
                </RemindDrawer>

                {/*{this.renderItem(Lang({ id: "YuLiuShiKeHu", default:'预流失客户' }),232)}*/}
            </div>
        </Spin>);
    }
}